import React, { Component } from 'react';
import Authentication from './Authentication';
require('firebase/firestore');

var firebase = require('firebase');
var db = firebase.firestore();



class Statecheck extends Component {
    constructor(props) {
        super(props);
        this.state = {
            signedIn: false,
            username: ''
        };
    };

    /**Create a unique key for each card to distinguish between each one  */
    uniqueKeyCreator = () => {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < 5; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
    }

    componentWillMount() {
        var referThis = this;
        //Check if the user has already logged in, if so lead to their profile page. if not, set the check status to False.  
        firebase.auth().onAuthStateChanged(function (user) {
            if (user) {
                /**
                 * Check if the user has "first == true" in their document, 
                 * if yes, then create nickname. If not, then check if their password field exists and if first === false 
                 * (for provider authentication)
                 */
                var docRef = db.collection("users").doc(user.email.toString());
                docRef.get().then(doc => {
                    let unique_username = user.displayName.replace(/ /g, "_") + "_" + referThis.uniqueKeyCreator();

                    if (doc && doc.exists) {
                        //This user has signed in before. 
                        referThis.setState({
                            signedIn: true,
                            username: unique_username
                        });
                    } else {
                        //Create a user spot
                        docRef.set({
                            name: user.displayName,
                            username: unique_username,
                            email: user.email,
                            photoUrl: user.photoURL,
                            uid: user.uid,
                            emailVerified: user.emailVerified,
                        }, { merge: true })
                            .catch(error => {
                                window.alert("There was an alert submitting this information!");
                                window.alert("Error: " + error);
                                referThis.setState({
                                    signedIn: false,
                                });
                            })
                            .then(function (success) {
                                console.log("Success sending the data!!");
                                referThis.setState({
                                    signedIn: true,
                                    username: unique_username
                                });
                            })

                    }

                }).catch(err => {
                    console.log("There was an error getting user data!");
                });




                /*user.getIdToken().then(function (data) {
                    window.alert("User Token: " + data)
                    referThis.setState({
                        userToken: data
                    });
                }); */

                /*user.sendEmailVerification().then(function(){
                    console.log("Verification Email Sent!");
                }).catch(function(emailError){
                    console.log("email error: " + emailError.code);
                }) */

            } else {
                referThis.setState({
                    signedIn: false
                });
            }
        }, function (error) {
            //Add a function where if there was an error, send an email to me 
            window.alert("There was an error: " + error.code + "\n Please try again later");
            console.log("Error Message: " + error.message);
            referThis.setState({
                signedIn: false
            });
        });
    }

    render() {
        if (this.state.signedIn) {
            //console.log("UID: " + this.state.uid);
            window.location.replace(`/developers/${this.state.username}`)
            /* return (
                 <small>
                     {this.state.userToken}
                 </small>
             ) */
            /*return (
                <Dashboard userInfo={this.state} />
            );*/
        } else {
            //The user is not logged in so return the Login page
            return (
                <Authentication />
            );
        }
    }
}
export default Statecheck;


// WEBPACK FOOTER //
// ./src/Authentication/Statecheck.js